<cappus-dto-common-status [isActive]="value() === 'Active'" />
